import { AUCTION_TYPES } from 'constants';
import { useIsAlternativeAuction } from 'hooks';
import styled from 'styled-components';
import { Vehicle } from 'types/vehicle';

type Props = {
  vehicle: Vehicle;
};

const StyledLabel = styled.div<{ bg: string }>`
  border-radius: 8px;
  height: 14px;
  width: fit-content;
  padding: 0 4px;

  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.bg};

  font-weight: 400;
  font-size: 8px;
  line-height: 100%;
  color: #fff;
`;

const auctionConfig: Record<string, { bg: string; label: string }> = {
  frontline: { bg: '#225A91', label: 'Frontline' },
  second_chance: { bg: '#3994DE', label: 'Second Chance' }
};

export const AuctionLabel = ({ vehicle }: Props) => {
  const isAlternativeAuction = useIsAlternativeAuction(vehicle);
  if (!isAlternativeAuction) return null;

  const { bg, label } = auctionConfig[vehicle.auction.type];

  return <StyledLabel bg={bg}>{label}</StyledLabel>;
};
